<template>
  <button
    class="font-sans text-text-tertiary text-[13px] font-medium"
    @click.capture.stop="toggleAutoTranslate"
  >
    {{
      isTranslated
        ? !hasTranslation
          ? $t("channel.translation.translating")
          : $t("channel.translation.seeOriginal")
        : $t("channel.translation.seeTranslation")
    }}
  </button>
</template>

<script setup lang="ts">
import { useResponsiveHelpers } from "@/composables/global/use-responsive-helpers";
import { useTranslationStore } from "@/stores/translation.store";

defineProps<{
  hasTranslation: boolean;
  isTranslated: boolean;
}>();

const autoTranslate = defineModel<boolean | null>("autoTranslate", {
  required: true,
});

const { desktop: _desktop } = useResponsiveHelpers();
const translationStore = useTranslationStore();

function toggleAutoTranslate() {
  // If the toggling causes the value to be in sync with the global setting,
  // we set it to null to indicate that it should be controlled by the global setting.
  const nextValue = !(autoTranslate.value ?? translationStore.autoTranslateOn);
  autoTranslate.value =
    nextValue === translationStore.autoTranslateOn ? null : nextValue;
}
</script>
